module.exports = __webpack_public_path__ + "media/img/help_center/Student_Account_Creation_04-20e7e9cbc981935d8cdf8b1f84b255b7.jpg";